import React from 'react';
import Container from "@material-ui/core/Container";
//import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import SettingsDrawer from "../../components/SettingsDrawer";
import {ReactComponent as MainLogo} from "../../logoSmall2.svg";
import Grid from "@material-ui/core/Grid";
import {Box} from "@material-ui/core";
import DashboardFooter from "../DashboardFooter";
import Support from "../Support";

// const useStyles = makeStyles((theme) => ({
//     box: {
//         marginLeft: '16px', marginRight: '16px', marginTop: '19px', width: '100%', paddingBottom: '100px'
//     },
// }));

export default function MainLayout({children}) {

    return (
        <React.Fragment>
            <AppBar position="static" color="default">
                <Toolbar>
                    <Grid container direction="row"
                          justify="space-between"
                          alignItems="flex-end"
                          style={{height: '100px'}}
                    >
                        <Box>
                            <a href={'https://www.carwiser.com'} target={'_blank'} rel="noopener noreferrer">
                                <MainLogo style={{height: '40px', width: '169px'}}/></a>
                        </Box>
                    </Grid>
                    <section>
                        <SettingsDrawer/>
                    </section>
                </Toolbar>
            </AppBar>
            <Container style={{paddingLeft: "16px", paddingRight: "16px", paddingBottom: "28px", maxWidth: "800px"}}>
                <Box>
                    {children}
                    <Support />
                    <DashboardFooter/>
                </Box>
            </Container>
        </React.Fragment>
    );
}